import { GetBodyRecievedCorrectiveParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyRecievedCorrectiveImages/getBodyRecievedCorrectiveImages.type';
import { getBodyRecievedCorrectiveImagesFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyRecievedCorrectiveImages/getBodyRecievedCorrectiveImagesFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyRecievedCorrectiveImagesOptions = ({
  id,
}: GetBodyRecievedCorrectiveParamsType) => {
  return queryOptions({
    queryKey: ['GET_BODY_RECIEVED_CORRECTIVE_IMAGES_OPTIONS', id],
    queryFn: () => getBodyRecievedCorrectiveImagesFunction({ id }),
  });
};
